// extracted by mini-css-extract-plugin
module.exports = {"testimonals":"TailwindTestimonials-styles-module--testimonals--1tXGo","quotes":"TailwindTestimonials-styles-module--quotes--re-nf"};